"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieceAnimationEventStore = void 0;
class PieceAnimationEventStore {
    constructor() {
        this.eventsByPiece = new Map();
        this.projectileEvents = [];
        this.listeners = new Set();
        this.version = 0;
        this.subscribe = (listener) => {
            this.listeners.add(listener);
            return () => {
                this.listeners.delete(listener);
            };
        };
        this.getSnapshot = () => this.version;
    }
    pushEvents(events) {
        for (const event of events) {
            const pieceId = event.pieceId;
            const existing = this.eventsByPiece.get(pieceId);
            if (existing) {
                existing.push(event);
            }
            else {
                this.eventsByPiece.set(pieceId, [event]);
            }
            if (event.type === "piece_attack" && event.ranged) {
                const attackEvent = event;
                this.projectileEvents.push({
                    type: "piece",
                    sourceId: attackEvent.pieceId,
                    targetPieceId: attackEvent.targetId,
                });
            }
        }
        this.version++;
        for (const listener of this.listeners) {
            listener();
        }
    }
    consumeProjectileEvents() {
        const events = this.projectileEvents;
        this.projectileEvents = [];
        return events;
    }
    consumeEventsForPiece(pieceId) {
        const events = this.eventsByPiece.get(pieceId);
        if (!events || events.length === 0) {
            return [];
        }
        this.eventsByPiece.delete(pieceId);
        return events;
    }
}
exports.PieceAnimationEventStore = PieceAnimationEventStore;
